import React, { useState, useEffect } from "react"
import { createVeriffFrame, MESSAGES } from "@veriff/incontext-sdk"
import { Button, Grid } from "@ridecell/web-components-material"
import { injectIntl } from "react-intl"

import useGlobalContext from "../../../utils/customHooks/useGlobalContext"
import messages from "./messages"

const VeriffIdentityVerification = ({
  handleNext,
  intl: { formatMessage },
}) => {
  const {
    state: { veriffSessionData },
  } = useGlobalContext()
  const [startVerification, setStartVerification] = useState(true)
  const VERIFF_SESSION_URL =
    sessionStorage.getItem("@veriff-session-url") ||
    veriffSessionData?.verification?.url
  useEffect(() => {
    if (startVerification) {
      const veriff = createVeriffFrame({
        url: VERIFF_SESSION_URL,
        onEvent: (msg) => {
          switch (msg) {
            case MESSAGES.CANCELED:
              setStartVerification(false)
              break
            case MESSAGES.FINISHED:
              handleNext()
              break
            default:
              return
          }
        },
        onReload: () => {
          // Logic to re-open Veriff SDK after page reload
          sessionStorage.setItem("@veriff-session-url", VERIFF_SESSION_URL)
          window.location.reload()
        },
      })

      return () => {
        veriff.close()
      }
    }
  }, [VERIFF_SESSION_URL, startVerification])

  return (
    <Grid container direction="column" justify="center" alignItems="center">
      <Button
        className="veriff-root"
        onClick={() => setStartVerification(true)}
      >
        {formatMessage(messages.startVerification)}
      </Button>
    </Grid>
  )
}

export default injectIntl(VeriffIdentityVerification)
